/* Signature - Shopify-native product recommendations with strict response
   filtering. The section stays hidden on empty or failed requests. */
(function (global) {
  'use strict';

  function productId(item) {
    const card = item && item.querySelector('[data-product-id]');
    return card && card.getAttribute('data-product-id');
  }

  function uniqueItems(items, currentProductId, limit, getId) {
    const seen = new Set();
    const result = [];
    const identify = getId || productId;

    for (const item of items) {
      const id = String(identify(item) || '');
      if (!id || id === String(currentProductId || '') || seen.has(id)) continue;
      seen.add(id);
      result.push(item);
      if (result.length >= limit) break;
    }
    return result;
  }

  async function load(container, dependencies) {
    const deps = dependencies || {};
    const request = deps.fetch || global.fetch;
    const parse = deps.parse || ((html) =>
      new DOMParser().parseFromString(html, 'text/html'));
    const grid = container.querySelector('[data-recommendations-grid]');
    const currentProductId = container.getAttribute('data-current-product-id') || '';
    const limit = Math.max(1, Number(container.getAttribute('data-limit')) || 4);

    container.hidden = true;
    if (grid) grid.replaceChildren();

    try {
      const response = await request(container.getAttribute('data-url'), {
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error('Recommendations request failed');

      const rendered = parse(await response.text());
      const renderedGrid = rendered.querySelector('[data-recommendations-grid]');
      if (!grid || !renderedGrid) return false;

      const recommendations = uniqueItems(
        Array.from(renderedGrid.children),
        currentProductId,
        limit
      );
      if (!recommendations.length) return false;

      grid.replaceChildren(...recommendations);
      container.hidden = false;
      return true;
    } catch (error) {
      return false;
    }
  }

  function init(scope) {
    scope.querySelectorAll('[data-product-recommendations]').forEach((container) => {
      if (container.hasAttribute('data-recommendations-loading')) return;
      container.setAttribute('data-recommendations-loading', '');
      load(container);
    });
  }

  global.SignatureRecommendations = { init, load, uniqueItems };
  if (global.document) init(global.document);
})(typeof window === 'undefined' ? globalThis : window);
